module.exports = {"id":"111093","name":"Reyes","rating":"78","photo":"./data/images/photos/0/111093.png","club":{"name":"Córdoba CF","logo":"./data/images/clubs/CordobaCF.png"},"positions":["MD","MG","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Reyes0.json
// module id = 3581
// module chunks = 0